module.exports = __webpack_public_path__ + "static/wpack/extracted/icon--space-cococanvas5be85caf9bc17a7535329f44000c29c0.svg";